// extracted by mini-css-extract-plugin
module.exports = {"viewports":"\"../../../viewports.css\"","desktop":"1024px","story-editor-card-number":"listicle-card_story-editor-card-number__16x21"};